import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseTableModule } from "../../@fuse/components/table";
import { FuseSelectionTreeModule } from '@fuse/components/selection-tree';
import { FuseCreateTaskModule } from "../../@fuse/components/create-task";
import { FileManagerModule } from "../../@fuse/components/file-manager";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatNativeDateModule } from "@angular/material/core";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { MatDividerModule } from "@angular/material/divider";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatListModule } from "@angular/material/list";
import { FuseAlertModule } from '@fuse/components/alert';
import { TableModule } from "primeng/table";
import { MatChipsModule } from '@angular/material/chips';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseCardModule } from '@fuse/components/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { QuillModule } from 'ngx-quill';
import { FuseSelectSearchPipeModule } from '@fuse/pipes/select-search';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmPasswordValidatorDirective } from './directives/confirmpassword-validator.directive';
import { CustomPasswordValidatorDirective } from './directives/custom-password-validator.directive';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DragDirective } from './directives/dragDrop.directive';
import { ScheduleReminderComponent } from './components/schedule-reminder/schedule-reminder.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
    declarations: [ConfirmPasswordValidatorDirective, CustomPasswordValidatorDirective, DragDirective, ScheduleReminderComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        TranslocoModule,
        MatButtonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FuseTableModule,
        FuseSelectionTreeModule,
        FileManagerModule,
        MatIconModule,
        MatButtonModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatMomentDateModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatInputModule,
        MatMenuModule,
        MatListModule,
        FuseAlertModule,
        TableModule,
        MatChipsModule,
        FuseLoadingBarModule,
        FuseCreateTaskModule,
        FuseCardModule,
        MatAutocompleteModule,
        QuillModule,
        NgxDropzoneModule,
        FuseSelectSearchPipeModule,
        MatDialogModule,
        ConfirmPasswordValidatorDirective,
        CustomPasswordValidatorDirective,
        DragDirective,
        ScheduleReminderComponent
    ],

})
export class SharedModule {
}
